<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isDialogOpen: false,
    }
  },
  computed: {
    sessionStatus() {
      if (this.item.accessDate) {
        const now = new Date().getTime()
        const timeLimit =
          Number(this.item.accessLimit) * 60000 + this.item.accessDate.getTime()
        if (now > timeLimit) {
          return 'Expired'
        } else {
          return 'Active'
        }
      } else {
        return 'Not Started'
      }
    },
    formatDate() {
      console.log(this.item.accessDate)
      var options = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }
      if (this.item.accessDate) {
        return this.item.accessDate.toLocaleDateString('en-GB', options)
      } else {
        return ''
      }
    },
    formatTime() {
      var options = { hour: '2-digit', minute: '2-digit' }
      if (this.item.accessDate) {
        return this.item.accessDate.toLocaleTimeString('en-GB', options)
      } else {
        return ''
      }
    },
  },
  mounted() {},
  methods: {
    deleteUser() {
      this.$store.dispatch('qa/deleteUser', this.item)
    },
  },
}
</script>

<template>
  <li class="useritem">
    <div class="basicinfo">
      <div class="md-list-item-text">
        <span>{{ item.name }}</span>
      </div>
      <div class="md-list-item-text">
        <span>{{ item.candidate }}</span>
      </div>
      <div class="md-list-item-text">
        <span>{{ item.password }}</span>
      </div>
      <div class="md-list-item-text">
        <span>{{ item.accessLimit }}</span>
      </div>
      <div class="md-list-item-text">
        <span>{{ formatDate }} {{ formatTime }}</span>
      </div>
      <div class="md-list-item-text">
        <span>{{ sessionStatus }}</span>
      </div>
      <div class="md-list-item-text">
        <button @click="isDialogOpen = !isDialogOpen">Delete user</button>
      </div>
      <md-dialog-confirm
        :md-active.sync="isDialogOpen"
        md-title="Delete user"
        :md-content="`Are you sure you want to delete user ${item.name}?`"
        md-confirm-text="Delete"
        @md-confirm="deleteUser" />
    </div>
  </li>
</template>

<style lang="scss" scoped>
@import '@design';

.useritem {
  display: block;
  list-style-type: none;

  &:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .basicinfo {
    display: grid;
    grid-template-columns: auto 200px 200px 100px 200px 200px 100px;
    align-items: center;
  }

  .md-list-item-text {
    margin-block: 0.25rem;
  }

  .md-list-item-content {
    align-items: normal;
  }
}

.testcontent {
  padding: 0 24px;
}
</style>
